import type { ReactNode } from "react";

/** Red asterisk for required fields (matches registration flow styling). */
export function RegReqLabel(props: { children: ReactNode; required?: boolean }) {
  return (
    <span className="reg-label-line">
      {props.children}
      {props.required ? (
        <span className="reg-required" aria-hidden="true">
          *
        </span>
      ) : null}
    </span>
  );
}
